package games.polyclub.website.frontend.store.layout

import games.polyclub.frontend.lib.react.simplified.SFC
import games.polyclub.frontend.lib.react.utils.useEffectAsync
import games.polyclub.website.frontend.store.appScope
import games.polyclub.website.frontend.store.hooks.useAuth
import kotlinx.coroutines.delay
import react.Props
import react.createRef
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.img
import web.html.HTMLDivElement
import kotlin.time.Duration.Companion.seconds

val PreloadAnimation = SFC<Props> { _->
    val authCtx = useAuth()
    val show = authCtx.showPosLoadEffect
    val setShow = authCtx.setShowPosLoadEffect
    val divRef = createRef<HTMLDivElement>()

    appScope.useEffectAsync(show, divRef) {
        if (show) {
            while (true) {
                if (divRef.current?.style?.height == "0px") {
                    setShow(false)
                    break
                }
                delay(1.seconds)
            }
        }
    }

    if (show) {
        div("preloader flex-column justify-content-center align-items-center") {
            ref = divRef
            img("animation__shake") {
                src = "/img/logo.png"
                alt = "PolyClubLogo"
                height = 102.0
                width = 661.0
            }
        }
    }
}
